module.exports = __webpack_public_path__ + "img/star.59d5c39a.svg";